import ApiService from "@/core/services/api.service";

export const GUARANTEE_VIDEO_LIST = "guaranteeVideoList";
export const GUARANTEE_VIDEO_STORE = "guaranteeVideoStore";
export const GUARANTEE_VIDEO_UPDATE = "guaranteeVideoUpdate";
export const GUARANTEE_VIDEO_DELETE = "guaranteeVideoDelete";

const PATH = "guarantee-videos";

const state = {
    videos: [],
    pagination: null,
    loading: false,
};

const getters = {
    guaranteeVideos: (state) => state.videos,
    guaranteeVideoPagination: (state) => state.pagination,
};

const actions = {
    [GUARANTEE_VIDEO_LIST](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.query(PATH, params)
                .then(({ data }) => resolve(data))
                .catch((error) => reject(error));
        });
    },
    [GUARANTEE_VIDEO_STORE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH, payload)
                .then(({ data }) => resolve(data))
                .catch((error) => reject(error));
        });
    },
    [GUARANTEE_VIDEO_UPDATE](context, { id, payload }) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${PATH}/${id}`, payload)
                .then(({ data }) => resolve(data))
                .catch((error) => reject(error));
        });
    },
    [GUARANTEE_VIDEO_DELETE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(PATH, id)
                .then(({ data }) => resolve(data))
                .catch((error) => reject(error));
        });
    },
};

const mutations = {};

export default { state, actions, mutations, getters };
